import { useContext } from 'react';
import { WagmiAuthContext } from 'app/providers';

export const useWagmiAuth = () => {
  return useContext(WagmiAuthContext);
};
